import { createFileRoute, redirect } from '@tanstack/react-router';

import { TRY_EDITORS_ENABLED, tryGateResult } from '@/config/try-editors';
import { TryEditorPage } from '@/pages/try-editor/try-editor-page';

export const Route = createFileRoute('/try/knit')({
    beforeLoad: ({ context }) => {
        const gate = tryGateResult(context.auth.isSignedIn === true, TRY_EDITORS_ENABLED);
        // Signed-in users have the real editor — never show them the taste.
        if (gate.kind === 'redirect-signed-in') throw redirect({ to: '/grid-editor' });
        // Pre-launch: same wall gated visitors hit everywhere else.
        if (gate.kind === 'redirect-gated') {
            throw redirect({ to: '/sign-in/$', params: { _splat: '' } });
        }
    },
    component: TryKnitRoute,
});

function TryKnitRoute() {
    return <TryEditorPage kind="knitting" />;
}
